const STORAGE_KEY = 'veiassistent_notifications';
const MAX_NOTIFICATIONS = 100;

export const SEVERITY = {
  WARNING: 'warning',
  CRITICAL: 'critical',
};

export const NOTIFICATION_TYPES = {
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  MULTIPLE_VEHICLES_REMOVED: 'multiple_vehicles_removed',
  FAILED_LOGIN: 'failed_login',
};

const getUserId = () => {
  try {
    const session = JSON.parse(localStorage.getItem('veiassistent_session') || 'null');
    return session?.id || 'unknown';
  } catch {
    return 'unknown';
  }
};

export const getNotifications = (userId = null) => {
  try {
    const uid = userId || getUserId();
    const store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return store?.[uid] || [];
  } catch {
    return [];
  }
};

export const getUnreadCount = () => {
  const notifications = getNotifications();
  return notifications?.filter(n => !n?.read)?.length;
};

export const addNotification = ({ type, severity, title, message, metadata = {} }) => {
  try {
    const uid = getUserId();
    const store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    if (!store?.[uid]) store[uid] = [];
    const notification = {
      id: `notif-${Date.now()}-${Math.random()?.toString(36)?.slice(2, 6)}`,
      type,
      severity,
      title,
      message,
      metadata,
      timestamp: new Date()?.toISOString(),
      read: false,
    };
    store?.[uid]?.unshift(notification);
    if (store?.[uid]?.length > MAX_NOTIFICATIONS) {
      store[uid] = store?.[uid]?.slice(0, MAX_NOTIFICATIONS);
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    window?.dispatchEvent(new CustomEvent('veiassistent_notification', { detail: notification }));
    return notification;
  } catch {
    return null;
  }
};

export const markAsRead = (notificationId) => {
  try {
    const uid = getUserId();
    const store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    if (!store?.[uid]) return;
    store[uid] = store?.[uid]?.map(n =>
      n?.id === notificationId ? { ...n, read: true } : n
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch { }
};

export const markAllAsRead = () => {
  try {
    const uid = getUserId();
    const store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    if (!store?.[uid]) return;
    store[uid] = store?.[uid]?.map(n => ({ ...n, read: true }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch { }
};

const VEHICLE_REMOVAL_KEY = 'veiassistent_vehicle_removals';
const REMOVAL_WINDOW_MS = 10 * 60 * 1000;

export const trackVehicleRemoval = (vehicleLabel) => {
  try {
    const uid = getUserId();
    const store = JSON.parse(localStorage.getItem(VEHICLE_REMOVAL_KEY) || '{}');
    if (!store?.[uid]) store[uid] = [];
    const now = Date.now();
    store[uid] = store?.[uid]?.filter(ts => now - ts < REMOVAL_WINDOW_MS);
    store?.[uid]?.push(now);
    localStorage.setItem(VEHICLE_REMOVAL_KEY, JSON.stringify(store));
    const count = store?.[uid]?.length;
    if (count >= 2) {
      addNotification({
        type: NOTIFICATION_TYPES?.MULTIPLE_VEHICLES_REMOVED,
        severity: SEVERITY?.CRITICAL,
        title: 'Flere kjøretøy fjernet',
        message: `${count} kjøretøy er fjernet fra flåten din innen kort tid. Siste: ${vehicleLabel}`,
        metadata: { count, vehicleLabel },
      });
    }
  } catch { }
};

export const trackSubscriptionCancellation = () => {
  addNotification({
    type: NOTIFICATION_TYPES?.SUBSCRIPTION_CANCELLED,
    severity: SEVERITY?.CRITICAL,
    title: 'Abonnement avsluttet',
    message: 'Premium-abonnementet ditt har blitt avsluttet. Du har nå tilgang til gratis-funksjoner.',
    metadata: { cancelledAt: new Date()?.toISOString() },
  });
};

export const trackFailedLogin = (email) => {
  try {
    const FAILED_LOGIN_KEY = 'veiassistent_failed_logins';
    const store = JSON.parse(localStorage.getItem(FAILED_LOGIN_KEY) || '{}');
    const key = email?.toLowerCase() || 'unknown';
    if (!store?.[key]) store[key] = { count: 0, firstAt: Date.now() };
    store[key].count += 1;
    store[key].lastAt = Date.now();
    localStorage.setItem(FAILED_LOGIN_KEY, JSON.stringify(store));
    const count = store?.[key]?.count;
    if (count >= 3) {
      try {
        const users = JSON.parse(localStorage.getItem('veiassistent_users') || '[]');
        const user = users?.find(u => u?.email?.toLowerCase() === key);
        if (user?.id) {
          const storeNotif = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
          if (!storeNotif?.[user?.id]) storeNotif[user.id] = [];
          const notification = {
            id: `notif-${Date.now()}-${Math.random()?.toString(36)?.slice(2, 6)}`,
            type: NOTIFICATION_TYPES?.FAILED_LOGIN,
            severity: SEVERITY?.WARNING,
            title: 'Mislykkede innloggingsforsøk',
            message: `${count} mislykkede innloggingsforsøk registrert for kontoen din.`,
            metadata: { count, email: key },
            timestamp: new Date()?.toISOString(),
            read: false,
          };
          storeNotif?.[user?.id]?.unshift(notification);
          if (storeNotif?.[user?.id]?.length > MAX_NOTIFICATIONS) {
            storeNotif[user.id] = storeNotif?.[user?.id]?.slice(0, MAX_NOTIFICATIONS);
          }
          localStorage.setItem(STORAGE_KEY, JSON.stringify(storeNotif));
        }
      } catch { }
    }
  } catch { }
};
